import {initContentTabs} from "./contentTabs";
import {loadHubspotForm} from "./loadHubspotForm";
import {isEnglish} from "./language";
import {hasCookieConsent, onCookieConsent} from "./cookieConsent";
import {renderCookiePlaceholder} from "./cookiePlaceholder";

const HUBSPOT_PROVIDER_ID = 'hubspot';

/** Pro Modal nur ein Consent-Observer, auch wenn es mehrfach geoeffnet wird. */
const consentWatchers = new WeakMap();

function loadForm(modal, useEnglish) {
    const formContainer = modal.querySelector('.hubspotFormContainer[data-form-id]');
    if (!formContainer || formContainer.dataset.loaded) return;

    formContainer.dataset.loaded = 'true';
    const formLoader = formContainer.closest('.dcContentTabs__contentItem')?.querySelector('.requestBannerModal__loader');
    const formId = (useEnglish && formContainer.dataset.formIdEn) || formContainer.dataset.formId;

    if (window.dataLayer) {
        window.dataLayer.push({
            event: 'form_view',
            form_id: formId,
            form_name: formContainer.dataset.formName || document.title.replace(' - dc AG', ''),
            form_location: 'modal'
        });
    }

    const hubspotSelector = modal.id
        ? `#${modal.id} .hubspotFormContainer`
        : '.requestBannerModal .hubspotFormContainer';

    const personioId = document.querySelector('[data-personio-id]')?.dataset?.personioId;
    const hiddenFields = personioId ? { personio_job_id: personioId } : {};

    formLoader?.classList.remove('is-hidden');

    loadHubspotForm(formId, () => {
        formLoader?.classList.add('is-hidden');
        formContainer.classList.add('is-loaded');
    }, hubspotSelector, hiddenFields);
}

function loadMeeting(modal, useEnglish) {
    // DCCookie ersetzt den DIV bei Zustimmung durch ein echtes iframe und
    // uebernimmt dabei alle Attribute - der Selektor greift in beiden Faellen.
    const meetContainer = modal.querySelector('.meetIframeContainer[data-meet-src]');
    if (!meetContainer || meetContainer.dataset.loaded) return;

    meetContainer.dataset.loaded = 'true';
    const meetLoader = meetContainer.closest('.dcContentTabs__contentItem')?.querySelector('.requestBannerModal__loader');
    const meetSrc = (useEnglish && meetContainer.dataset.meetSrcEn) || meetContainer.dataset.meetSrc;

    meetLoader?.classList.remove('is-hidden');
    meetContainer.setAttribute('src', meetSrc);

    meetContainer.addEventListener('load', () => {
        meetLoader?.classList.add('is-hidden');
        meetLoader?.classList.add('is-loaded');
    });

    if (!document.querySelector('script[src*="MeetingsEmbedCode.js"]')) {
        const script = document.createElement('script');
        script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
        document.head.appendChild(script);
    }
}

export function initRequestBannerModal() {
    document.addEventListener('modalContentLoaded', function(e) {
        const modal = e.detail.data.target;
        initContentTabs(modal);

        if (!modal.classList.contains('requestBannerModal')) return;

        const useEnglish = isEnglish();

        // Das Formular laedt immer, unabhaengig vom Cookie-Consent.
        loadForm(modal, useEnglish);

        // Der Terminkalender (HubSpot Meetings) bleibt an die Zustimmung
        // gebunden. Er wird aus child.js heraus gestartet, also nicht von
        // DCCookie geblockt - deshalb hier explizit pruefen.
        if (hasCookieConsent(HUBSPOT_PROVIDER_ID)) {
            loadMeeting(modal, useEnglish);
            return;
        }

        const meetContainer = modal.querySelector('.meetIframeContainer[data-meet-src]');
        if (!meetContainer) return;

        // Ohne Zustimmung laedt nichts nach, der Spinner wuerde endlos laufen.
        meetContainer.closest('.dcContentTabs__contentItem')
            ?.querySelector('.requestBannerModal__loader')
            ?.classList.add('is-hidden');

        // DCCookie rendert fuer HubSpot keinen Hinweis (Kategorie marketing,
        // siehe cookiePlaceholder.js). Vor den Container: DCCookie macht aus
        // dem DIV bei Zustimmung ein iframe und wuerde den Inhalt in das
        // iframe kopieren.
        renderCookiePlaceholder(meetContainer, HUBSPOT_PROVIDER_ID, {position: 'before'});

        if (consentWatchers.has(modal)) return;
        consentWatchers.set(modal, onCookieConsent(HUBSPOT_PROVIDER_ID, modal, () => {
            consentWatchers.delete(modal);
            loadMeeting(modal, isEnglish());
        }));
    });
}
